module.exports = __webpack_public_path__ + "img/22.a1bc42c7.jpg";